import { render, staticRenderFns } from "./add-update-resource.vue?vue&type=template&id=efa3d52a&scoped=true&"
import script from "./add-update-resource.vue?vue&type=script&lang=js&"
export * from "./add-update-resource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa3d52a",
  null
  
)

export default component.exports